define([
    'common/domain/action/index',
    'common/domain/repository/dispatcher',
    'common/infra/api/recent-change',
    'backbone'
], function(
    Actions,
    Dispatcher,
    RecentChangeApi,
    Backbone
    ){
    'use strict';

    var RecentChangeActionCreator = Backbone.Model.extend({
        initialize: function() {
            this._fetchedByKind = {};
        },

        fetchRecentChanges: function(kind, options) {
            return new Promise((resolve, reject) => {
                RecentChangeApi.getRecentChanges(kind, options)
                    .then(recentChanges => {
                        Dispatcher.dispatch({
                            type: Actions.CREATE_RECENT_CHANGE,
                            recentChange: recentChanges,
                            kind: kind,
                            options: {fetched: true}
                        });
                        resolve();
                    }, reject);
            });
        },

        fetchRecentChangesOnce: function(params) {
            const kind = params.kind;
            var deferred = this._fetchedByKind[kind];
            if(!deferred) {
                deferred = this.fetchRecentChanges(kind, params);
                this._fetchedByKind[kind] = deferred;
            }
            return deferred;
        }
    });

    return new RecentChangeActionCreator();
});



// WEBPACK FOOTER //
// ./common/domain/action/recent-change.js